webpackJsonp([4499673144076947000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/stud.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Alert = __webpack_require__("./src/components/Alert.js");
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Image = __webpack_require__("./src/components/Image.js");
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stud = function Stud() {
			return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
							'h1',
							null,
							'Stud Pugs'
					),
					_react2.default.createElement(
							'p',
							null,
							'We have two of our own pugs, Dudley and Poe, available for stud.'
					),
					_react2.default.createElement(
							'h4',
							null,
							'Dudley'
					),
					_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/static/pedigree/dudley_pedigree.jpg', onClick: function onClick() {
													return pageTracker._trackPageview('/pedigree/dudley');
											} },
									'View Dudley\'s Pedigree'
							),
							' '
					),
					_react2.default.createElement(
							'p',
							null,
							'Dudley is our fawn coloured stud dog. He is proven and has sired several litters. He is KC registered and is 7 years old.'
					),
					_react2.default.createElement(
							'p',
							null,
							'He has a very friendly nature and lives with us as part of our family.'
					),
					_react2.default.createElement(
							'p',
							null,
							'His stud fee is \xA3500'
					),
					_react2.default.createElement(
							_Image2.default,
							{ src: '/static/dudley-stud.jpg', alt: 'Dudley our stud pug', width: '347', height: '287' },
							_react2.default.createElement(
									'p',
									null,
									'Dudley, our dog that we have bred our litters from'
							)
					),
					_react2.default.createElement(
							'h4',
							null,
							'Poe'
					),
					_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/static/pedigree/poe_pedigree.jpg', onClick: function onClick() {
													return pageTracker._trackPageview('/pedigree/poe');
											} },
									'View Poe\'s Pedigree'
							),
							' '
					),
					_react2.default.createElement(
							'p',
							null,
							'Poe is our apricot coloured stud dog. He is proven and has also sired several litters. He is 5 years old and is KC registered.'
					),
					_react2.default.createElement(
							'p',
							null,
							'He has a very friendly nature and lives with us as part of our family.'
					),
					_react2.default.createElement(
							'p',
							null,
							'His stud fee is \xA3500'
					),
					_react2.default.createElement(
							_Image2.default,
							{ src: '/static/poe-stud.jpg', alt: 'Poe, our Apricot stud', width: '313', height: '287' },
							_react2.default.createElement(
									'p',
									null,
									'Poe, our Apricot stud'
							)
					)
			);
	};
	
	exports.default = Stud;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-stud-js-16b62e418b412f137944.js